import React from 'react';
import { Input } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

const reasons = [
  'I’m receiving too many emails.',
  'I never signed up for this mailing list.',
  'The emails are not relevant to me.',
  'My preferences or interests have changed.',
  'The emails are spam and should be reported.',
];

export default function UnsubscriptionReason() {
  const { control } = useFormContext();
  return (
    <>
      <p
        style={{
          lineHeight: '24px',
          marginBottom: 0,
          marginTop: 40,
          fontSize: 14,
          textAlign: 'center',
        }}
      >
        <i>
          We value your feedback and would appreciate it if you could let us
          know the reason for your decision to help us improve our services in
          the future
        </i>
      </p>
      <div className="space-y-1" style={{ marginTop: 10 }}>
        <Controller
          control={control}
          name="reason"
          render={({ field }) => {
            return (
              <>
                {reasons.map(unsubReason => (
                  <div className="flex space-x-2" key={unsubReason}>
                    <input
                      id={unsubReason}
                      name="unsubscribeReason"
                      type="radio"
                      value={unsubReason}
                      onChange={field.onChange}
                    />
                    <label
                      className="cursor-pointer"
                      htmlFor={unsubReason}
                      style={{ fontSize: 14 }}
                    >
                      {unsubReason}
                    </label>
                  </div>
                ))}
                <div className="flex space-x-2">
                  <input
                    id="other"
                    name="unsubscribeReason"
                    type="radio"
                    value=""
                    onChange={field.onChange}
                  />
                  <label
                    className="cursor-pointer"
                    htmlFor="other"
                    style={{ fontSize: 14 }}
                  >
                    Other (fill in reason below)
                  </label>
                </div>
                {field.value === '' ? (
                  <Controller
                    control={control}
                    name="otherReason"
                    render={({ field: otherReasonField }) => {
                      return (
                        <Input.TextArea
                          enterButton="Submit"
                          maxLength={1000}
                          placeholder="Your reason for unsubscribing"
                          rows={3}
                          style={{ marginTop: 5, fontSize: 14 }}
                          value={otherReasonField.value}
                          onChange={otherReasonField.onChange}
                        />
                      );
                    }}
                  />
                ) : null}
              </>
            );
          }}
        />
      </div>
    </>
  );
}
